import {
  DEVANAGARI_DIGITS,
  toEnglishDigits,
  toMarathiDigits,
  formatMarathiNumber,
  formatMarathiCurrency,
  phoneticToMarathi,
} from './marathi';

export {
  DEVANAGARI_DIGITS,
  toEnglishDigits,
  toMarathiDigits,
  formatMarathiNumber,
  formatMarathiCurrency,
  phoneticToMarathi,
};

export const normalizeEnglishDigitsInput = (value = '', maxLength) => {
  const digits = toEnglishDigits(String(value).normalize('NFKC')).replace(/\D/g, '');
  return Number.isInteger(maxLength) ? digits.slice(0, maxLength) : digits;
};

// Login identifiers and email addresses are deliberately limited to visible
// ASCII characters. This keeps these credentials interoperable even when the
// device keyboard is currently set to Marathi or another input language.
export const normalizeEnglishIdentifierInput = (value = '') => toEnglishDigits(String(value).normalize('NFKC'))
  .replace(/[^\x21-\x7E]/g, '');

export const normalizeEmailInput = (value = '') => normalizeEnglishIdentifierInput(value).slice(0, 254);

export const normalizeUsernameInput = (value = '') => toEnglishDigits(String(value).normalize('NFKC'))
  .replace(/[^A-Za-z0-9._@-]/g, '')
  .slice(0, 100);

export const normalizePhoneInput = (value = '') => normalizeEnglishDigitsInput(value, 10);

export const isValidPhone = (value = '') => /^\d{10}$/.test(normalizePhoneInput(value));

export const normalizeAadhaarInput = (value = '') => normalizeEnglishDigitsInput(value, 12);

export const isValidAadhaar = (value = '') => /^\d{12}$/.test(normalizeAadhaarInput(value));

export const isValidEmail = (value = '') => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim());

export const isValidUsername = (value = '') => /^[A-Za-z0-9._@-]{3,100}$/.test(String(value));

export const requiredMessage = label => `${label} आवश्यक आहे.`;

export const phoneMessage = 'कृपया वैध १० अंकी मोबाइल नंबर टाका.';

export const emailMessage = 'कृपया वैध ईमेल पत्ता टाका.';

export const hasSignedNumberCharacters = (value = '') => /[+-]/.test(String(value));

export const isNonNegativeNumberInput = (value = '') => {
  const text = toEnglishDigits(value).trim();
  return text === '' || (!hasSignedNumberCharacters(text) && /^\d+(\.\d+)?$/.test(text));
};

export const MAX_DOCUMENT_UPLOAD_BYTES = 5 * 1024 * 1024;
export const MAX_CERTIFICATE_DOCUMENTS = 25;

const CERTIFICATE_DOCUMENT_EXTENSIONS = {
  'image/jpeg': new Set(['jpg', 'jpeg']),
  'image/png': new Set(['png']),
  'image/webp': new Set(['webp']),
  'application/pdf': new Set(['pdf']),
};

export const documentFileValidationError = (file, maxBytes = MAX_DOCUMENT_UPLOAD_BYTES) => {
  if (!file) return 'type';
  if (file.size > maxBytes) return 'size';
  const mimeType = String(file.type || '').toLowerCase();
  const extension = String(file.name || '').split('.').pop()?.toLowerCase() || '';
  return CERTIFICATE_DOCUMENT_EXTENSIONS[mimeType]?.has(extension) ? '' : 'type';
};

export const isAllowedDocumentFile = (file, maxBytes = MAX_DOCUMENT_UPLOAD_BYTES) => {
  return documentFileValidationError(file, maxBytes) === '';
};
